import PropTypes from 'prop-types';
import React from 'react';
import {
	Box, Drawer, Tabs, Tab
} from '@mui/material';
import { Document, Page } from 'react-pdf';
import PrimaryButton from '../../../Common/Button/primary-button.js';
import { downloadPDF } from '../../../../utils/dowload-pdf.js';
import DisplaySign from '../../CKEditorComponent/CKEditorSidebar/display-sign.js';
import { ReactComponent as CrossIcon } from '../../../../Assets/Images/close-circle-grey.svg';
import RenderDetails from './render-details.js';
import './pdfdetails-mobile.css';

const PDFDetailsMobile = ({
	open,
	onClose,
	selectedTab,
	handleChange,
	pdfContainerRef,
	handleScroll,
	file,
	onDocumentLoadSuccess,
	View,
	numPages,
	currentPage,
	signCoordinates,
	displayedRecipients,
	showAll,
	initialDisplayCount,
	toggleShowAll,
	handleApprove,
	handleReject,
	hideAction = false,
	showSign = false
}) => (
	<Drawer
		anchor='bottom'
		open={open}
		onClose={onClose}
		ModalProps={{ keepMounted: false }}
		sx={{
			'.MuiPaper-root': {
				height: 'calc(100vh - 150px)',
				overflow: 'visible',
				backgroundColor: '#000',
				color: '#fff',
				borderTopLeftRadius: '16px',
				borderTopRightRadius: '16px',
				padding: '5px 10px 0'
			}
		}}
	>
		<Box
			sx={{
				ml: '24px',
				display: 'flex',
				justifyContent: 'center',
				marginBottom: '10px'
			}}
			onClick={onClose}
		>
			<CrossIcon
				style={{
					stroke: 'white',
					cursor: 'pointer',
					width: '24px',
					height: '24px'
				}}
			/>
		</Box>

		<Box sx={{ width: '100%', height: '100%' }}>
			<Box sx={{ borderBottom: 1, borderColor: '#ECF0E5' }}>
				<Tabs
					value={selectedTab}
					onChange={handleChange}
					aria-label='basic tabs example'
					sx={{
						'.MuiTab-textColorPrimary': {
							color: '#ECF0E5'
						},
						'.MuiTabs-flexContainer': {
							justifyContent: 'space-around'
						}
					}}
				>
					<Tab label='Document' />
					<Tab label='Recipients Details' />
				</Tabs>
			</Box>
			{selectedTab === 0 && (
				<div style={{ width: '100%', overflow: 'hidden', padding: '10px 0' }}>
					<style>
						{`
              /* Hide scrollbar for webkit-based browsers (Chrome, Safari) */
              ::-webkit-scrollbar {
                display: none;
              }
              /* Hide scrollbar for Firefox */
              scrollbar-width: none;
              -ms-overflow-style: none;
            `}
					</style>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div
							style={{
								maxWidth: '300px',
								overflow: 'hidden',
								textOverflow: 'ellipsis'
							}}
						>
							{file?.documentName}
						</div>
						{numPages > 0 && (
							<p>
								{currentPage}/{numPages}
							</p>
						)}
					</div>
					<div
						className='pdfpreview-container'
						style={{ display: 'flex', justifyContent: 'center' }}
					>
						<div
							style={{
								maxHeight: 'calc(100vh - 250px)',
								overflowX: 'auto',
								position: 'relative',
								borderRadius: '8px',
								width: '100%'
							}}
							ref={pdfContainerRef}
							onScroll={handleScroll}
						>
							<div
								style={{
									borderRadius: '8px',
									position: 'relative'
								}}
							>
								<Document
									className='approval-pdf_container'
									file={file?.documentPdf}
									onLoadSuccess={onDocumentLoadSuccess}
									loading={View}
								>
									{Array.from({ length: numPages }, (_, index) => (
										<div
											key={index}
											className='approval-pdf-page'
											style={{
												width: `${signCoordinates[index]?.coord.pageWidth}px`,
												height: `${signCoordinates[index]?.coord.pageHeight}px`,
												position: 'relative'
											}}
										>
											<Page
												pageNumber={index + 1}
												renderTextLayer={false}
												renderAnnotationLayer={false}
											/>
											{showSign
												&& file?.recipientData?.map((item) =>
													item.coordinates
														?.filter((el) => el.pageNo === index + 1)
														?.map((coord, coordIndex) => (
															<div
																className='approval-pdf-sign'
																key={'coord' + coordIndex}
																style={{
																	position: 'absolute',
																	top: coord.y,
																	left: coord.x,
																	userSelect: 'none'
																}}
															>
																<DisplaySign
																	Rname={[
																		item.recipientFirstName,
																		item.recipientMiddleName,
																		item.recipientLastName
																	]
																		.filter(Boolean)
																		.join(' ')}
																/>
															</div>
														))
												)}
											<hr className='pagedevide' />
										</div>
									))}
								</Document>
							</div>
						</div>
					</div>
				</div>
			)}
			{selectedTab === 1 && (
				<div
					className='OrderDetailStyle'
					style={{ height: hideAction ? '85%' : '80%' }}
				>
					<div>
						<RenderDetails
							displayedRecipients={displayedRecipients}
							file={file}
							downloadPDF={downloadPDF}
							showAll={showAll}
							toggleShowAll={toggleShowAll}
							initialDisplayCount={initialDisplayCount}
							totalRecipients={file?.recipientData?.length}
							showCompare={file?.status === 'Awaiting Edit Approval'}
							documentId={file?.documentId}
						/>
					</div>
					{!hideAction && (
						<div>
							<div
								style={{
									padding: '10px 0 0',
									display: 'flex',
									flexDirection: 'column',
									gap: '10px'
								}}
							>
								<PrimaryButton
									value='Approve & Send'
									onClick={handleApprove}
									backgroundColor='#B7D423'
									padding='10px 16px'
									textcolor='#000000'
									width='100%'
									height='40px'
									borderRadius='8px'
								/>
								<PrimaryButton
									value={'Reject'}
									onClick={handleReject}
									textcolor='#E96666'
									padding='10px 16px'
									width='100%'
									height='40px'
									backgroundColor='transparent'
									borderRadius='8px'
									border='2px solid #E96666'
								/>
							</div>
						</div>
					)}
				</div>
			)}
		</Box>
	</Drawer>
);

export default PDFDetailsMobile;

PDFDetailsMobile.propTypes = {
	open: PropTypes.any,
	onClose: PropTypes.any,
	selectedTab: PropTypes.any,
	handleChange: PropTypes.any,
	pdfContainerRef: PropTypes.any,
	handleScroll: PropTypes.any,
	file: PropTypes.any,
	onDocumentLoadSuccess: PropTypes.any,
	View: PropTypes.any,
	numPages: PropTypes.any,
	currentPage: PropTypes.any,
	signCoordinates: PropTypes.any,
	displayedRecipients: PropTypes.any,
	showAll: PropTypes.any,
	initialDisplayCount: PropTypes.any,
	toggleShowAll: PropTypes.any,
	handleApprove: PropTypes.any,
	handleReject: PropTypes.any,
	hideAction: PropTypes.any,
	showSign: PropTypes.any
};
